/**
 * Слэш с пробелами после конца предложения (. ! ?) — разделитель между предложениями,
 * а не перенос строки внутри одного предложения.
 */
/** Обычный / и полноширинный ／ (часто при копировании из документов) */
export const SLASH_AFTER_SENTENCE = /(?<=[.!?])\s*[\u002F\uFF0F]\s*/;

export function splitIntoSentencePartsBySlash(str) {
    if (str == null || str === '') return [];
    const norm = String(str).replace(/\u00A0/g, ' ');
    const parts = norm.split(SLASH_AFTER_SENTENCE).map((s) => s.trim()).filter(Boolean);
    return parts.length ? parts : [norm.trim()];
}

/**
 * Разбор полного текста урока в список предложений (EN или RU).
 */
export function parseSentencesFromFullText(fullText) {
    if (fullText == null || fullText === '') return [];
    const norm = String(fullText).replace(/\u00A0/g, ' ');
    const afterSlash = norm.split(SLASH_AFTER_SENTENCE).map((s) => s.trim()).filter(Boolean);
    const subsplit = (chunk) => {
        const m = chunk.match(/[^.!?]+[.!?]+/g);
        if (m && m.length) return m.map((s) => s.trim());
        return [chunk.trim()];
    };
    if (afterSlash.length > 1) {
        return afterSlash.flatMap(subsplit);
    }
    const m = norm.match(/[^.!?]+[.!?]+/g);
    if (m && m.length) return m.map((s) => s.trim());
    return [norm.trim()];
}

/**
 * Строки из БД: если в одном поле несколько предложений через «. / », разворачиваем в несколько строк.
 */
export function expandSentenceRows(rows) {
    if (!rows || !rows.length) return [];
    const out = [];
    rows.forEach((row) => {
        const enParts = splitIntoSentencePartsBySlash(row.sentence_en);
        const ruRaw = row.sentence_ru;
        const ruParts = ruRaw != null && ruRaw !== '' ? splitIntoSentencePartsBySlash(ruRaw) : [];
        const n = Math.max(enParts.length, ruParts.length, 1);
        for (let i = 0; i < n; i++) {
            out.push({
                ...row,
                sentence_en: enParts[i] ?? '',
                sentence_ru: ruParts[i] ?? '',
            });
        }
    });
    return out;
}
